import { datadogLogs } from "@datadog/browser-logs";
import type {
    LogLayerTransportParams,
    LogLevelType,
} from "@loglayer/transport";
import { DataDogBrowserLogsTransport } from "@loglayer/transport-datadog-browser-logs";
import { LogLayer, ConsoleTransport } from "loglayer";

import { getBrowserEnvVar } from "./env.shared";

// Custom transport wrapper to filter messages
class FilteredConsoleTransport extends ConsoleTransport {
    shipToLogger({
        logLevel,
        messages,
        data,
        hasData,
    }: LogLayerTransportParams) {
        // AIDEV-NOTE: Confirmed this is reached; ensure console level shows these
        // Filter out "viewed screen" messages
        if (
            typeof messages[0] === "string" &&
            messages[0].includes("viewed screen")
        ) {
            return [];
        }
        // @ts-ignore
        super.shipToLogger({ logLevel, messages, data, hasData });
        return messages;
    }
}

class FilteredDataDogTransport extends DataDogBrowserLogsTransport {
    // AIDEV-NOTE: Use shipToLogger like other transports; filter noisy events
    shipToLogger({
        logLevel,
        messages,
        data,
        hasData,
    }: LogLayerTransportParams): any[] {
        if (
            typeof messages[0] === "string" &&
            messages[0].includes("viewed screen")
        ) {
            return [];
        }
        return super.shipToLogger({ logLevel, messages, data, hasData });
    }
}

const baseLogger = new LogLayer({
    transport: [
        new FilteredConsoleTransport({
            logger: console,
            // AIDEV-NOTE: Ensure browser console shows debug/info by default
            level: "debug" as LogLevelType,
        }),
        new FilteredDataDogTransport({
            logger: datadogLogs.logger,
        }),
    ],
});

// AIDEV-NOTE: withContext returns a new instance; capture it
export const logger = baseLogger.withContext({
    service: "app",
    env: getBrowserEnvVar("ENV_NAME"),
});
